// Angular:
import { Directive } from '@angular/core';

@Directive({
    selector: '[tmStepIndicatorIcon]'
})
export class StepIndicatorIconDirective {}
